<script>
export default {
  data() {
    return {
      isLoading: true,
      loadingTitle: '地址跳转中...',
      url:'https://h5.jingzong.net'
    }
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad(){
      this.isLoading = false
      this.axios.get(this.$tools.api_huiying + '?url=' + window.location.href)
      .then(response => {
          if(response.data.code == 200){
            this.goTo(response.data.data)
          }
      })   
    },
    goTo(url){
      //console.log(url)
      window.location.href =  url;
    }
  },
  metaInfo () {
    return {
      title: "页面跳转中..." 
    }
  },
};
</script>
<template>
  <div class="content">
    <van-loading size="24px" vertical v-bind:show="isLoading">{{loadingTitle}}</van-loading>
  </div>
</template>
<style lang="less">
  .content{
    margin: 150px 10px 10px 10px;
  }
</style>
